import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { Promise } from "es6-promise-polyfill";
import { DatePicker } from "core/classes/searchresults/search.date.picker";
import "core/classes/savebookmark/ajax.savebookmark.class";
import moment from "moment";
import "mdn-polyfills/Array.prototype.find";
import "mdn-polyfills/String.prototype.includes";
import { createBrowserHistory } from "history";
import { InitPopup } from "core/classes/popups/popup.class";
import "jquery/FilterHelpers/FilterHelpers";
import { TimeZoneFormat } from "core/classes/date.timezone.format.class.js";
import jump from "jump.js";

const history = createBrowserHistory();

let SearchAJAXOptions = {
  form: ".filteredSearch form",
  trigger:
    "[data-facet-params]:not(.applied-date-range-filter):not([data-ignore-default])",
  results: ".search-results-list",
  activefilter: ".activeFilters li a:not(.exclude-default-filter)",
  searchResultsFacets: ".refineBy"
};

class SearchAJAX extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(SearchAJAXOptions, options);
    this.shouldRun = true;
    this.selectedArr = [];
    this.data = this.element.find(".refineBy").data("searchResults");
    this.sortFacetItems(this.element.find(".facet:not(.byRating):not(.byDate)"));
    this.historyRequest();
    this.toggleFacet(this.element.find(".facet"), "h3");
    this.breakPoint();
    this.setUpEvents();
    this.ratingTabindex();
  }

  ratingTabindex(){
    let ratingList = this.element.find(".byRating ul li input");
    $(ratingList).each(function(i, ratingListItem){
      ratingListItem.tabIndex=0;
      let svgfocus = $(ratingListItem).parent().find('svg').get(0);
      $(svgfocus).attr("focusable", "false");
    })
  }

  breakPoint() {
    const mql = window.matchMedia("(max-width: 1023px)");
    function mqlTest(e) {
      if (e.matches) {
        $(".facet h3").trigger("click");
      } else {
        $("body").removeClass("mobile-ajax-overlay");
      }
    }
    mqlTest(mql);
    mql.addListener(mqlTest);
  }

  historyRequest() {
    var self = this;
    // Get the current location
    const location = history.location;

    // Listen for changes to the current location
    history.listen((location, action) => {
      if (self.shouldRun) {
        let data = $.extend(
          {},
          location.state || { qkeyword: this.data.qkeyword }
        );
        // console.log(location.state);
        data.selectorArr ? delete data.selectorArr : "";
        data.total ? delete data.total : "";

        let historyResponse = new Promise((resolve, reject) => {
          $.ajax({
            url: this.element.find(".searchDetails").data("searchUrl"),
            data,
            beforeSend: () => this.element.addClass("loading"),
            success: data => resolve(data)
          });
        });

        historyResponse
          .then(data => {
            let handlerData = JSON.parse(
                $(data)
                  .filter("script")
                  .html()
              ),
              htmlData = $(data)
                .filter("resulthtml")
                .html(),
              hierarchicalHTML = $(data)
                .filter("hierarchicalfacethtml")
                .html();

            self.data = $.extend(self.data, handlerData.results);

            $(window).trigger("abacus:ajaxsearchfilter:success", [self.selectedArr]);

            self.contentReplaceActiveFilters(htmlData);
            self.contentReplaceHeader(htmlData);
            self.contentReplaceMainAndPaging(htmlData, handlerData.results);

            $("#explorer-search-list").replaceWith(hierarchicalHTML);

            // console.log("START");
            if (typeof location.state !== "undefined") {
              // console.log(location.state.selectorArr);
            }

            // if there's a state
            if (location.state !== undefined) {
              self.removeDisabledStylesAndProps();
              // loop over array and select only that are checkboxes
              // then set their apropriate attributes
              for (let value in location.state.selectorArr) {
                // date range
                if (location.state.selectorArr[value].substring(0, 9) === "WVPUBDATE") {
                  $(".date-picker:not([disabled])").each((index, field) => {
                    this.applyDatePicker(field);
                    field.value = $(field).data("dateSelected");
                  });
                  // this.disableDateRangeFields(true);
                  // $(".date-picker").each((index, field) => {
                  //   this.applyDatePicker(field);
                  //   field.value = $(field).data("dateSelected");
                  // });
                  self.disableAllDateFields();
                } else {
                  // otherwise checkboxes
                  let field = $(`#${value}`)[0];
                  if (typeof value !== undefined && field&&field.type === "checkbox") {
                    if(field.checked){
                      field.checked = false;
                      field.removeAttribute('checked');
                    }else{
                      field.checked = true;
                      field.setAttribute('checked','checked');
                    }
                  }
                  // IF FIELD (FROM & TO)
                  // If value contains `WVPUBDATE` then reset filter
                  if ($(field).data("dateFilter")) {
                    self.disableSiblings(field, true);
                  }
                  self.highlightSelected(field);
                  self.switchParams(field);
                }
              }
              let dateRanges = location.state.parametrics.split(",").filter(param => param.indexOf("WVPUBDATE") != -1).map(range => (range.indexOf("WVPUBDATE")!=-1? range.replace("WVPUBDATE|",""):"")).map(x=>x.replace("[","").replace("]","")).join("").split(" TO ");
              if(dateRanges&&(location.state.cmd!="RmvPm"&&location.state.val.indexOf("WVPUBDATE")!=-1)){
                let dateFrom = document.querySelector("#dateFrom:not([disabled])"), dateTo = document.querySelector("#dateTo:not([disabled])");
      
                if(dateFrom&&dateRanges.length){
                  self.applyDatePicker(dateFrom);
                  dateFrom.value = dateRanges[0].split("T")[0];
                  dateFrom.setAttribute("data-selected",dateRanges[0].split("T")[0]);
                  dateFrom.setAttribute("data-date-from",dateRanges[0]);
                  dateFrom.disabled = true;
                  dateFrom.setAttribute("disabled","disabled");
                }
      
                if(dateTo&&dateRanges.length>1){
                  self.applyDatePicker(dateTo);
                  dateTo.value = dateRanges[1].split("T")[0];
                  dateTo.setAttribute("data-selected",dateRanges[1].split("T")[0]);
                  dateTo.setAttribute("data-date-to",dateRanges[1]);
                  dateTo.disabled = true;
                  dateTo.setAttribute("disabled","disabled");
                }
              }
            } else {
              self.removeDisabledStylesAndProps();
            }

            
            self.updateCount(handlerData.results.facets);
            if (handlerData.results.facets) delete handlerData.results.facets;
            
            self.updateCountsForMobile(handlerData);
            self.sortFacetItems(self.element.find(".facet:not(.byRating):not(.byDate)"));
            // console.log("END");
            self.ratingTabindex();
            
            if (typeof location.state !== "undefined") {
              // console.log(location.state.selectorArr);
            }

            $(window).trigger("abacus:ajaxsearch:complete", [self.element]);
          })
          .then(() => $(self.element).removeClass("loading"))
          .then(() => $(window).trigger("abacus:InitUI", [document.body]));
      }
    });

    $(window).on("abacus:ajaxsearch:success", (evt, selectorArr) => {
      self.shouldRun = false;

      self.data = $.extend(self.data, { selectorArr });
      let datacopy = $.extend({}, self.data);
      datacopy.selectorArr ? delete datacopy.selectorArr : "";
      datacopy.total ? delete datacopy.total : "";

      const data = $.param(datacopy);
      history.push(`${document.location.pathname}?${data}`, self.data);
    });
    $(window).on("abacus:ajaxsearch:complete", () => {
      self.shouldRun = true;
      $(".date").each(function(i, el) {
        new TimeZoneFormat(this);
      });
    });
  }

  disableDateRangeFields(clearValue) {
    $(".date-picker").each((index, field) => {
      this.applyDatePicker(field);
      if (clearValue) field.value = $(field).data("dateSelected");
    });
  }

  removeDisabledStylesAndProps() {
    // remove all disabled classes and props
    $("input[data-facet-params]")
      .prop("checked", false)
      .prop("disabled", false)
      .removeAttr("checked")
      .parent("li")
      .removeClass("selected filter-disabled");
    $(".searchdates li").removeClass("filter-disabled");
    $(".date-picker").each(function(i, picker) {
      picker.value = "";
      picker.removeAttribute("disabled");
    });
  }

  toggleFacet(facets, trigger) {
    facets.each(function(index, facet) {
      var self = $(facet);
      $(facet).on("click", trigger, function() {
        self.toggleClass("facet-open");
        if (
          $(self)
            .find(".facet-content")
            .prop("aria-hidden") === "true"
        ) {
          $(self)
            .find(".facet-content")
            .prop("aria-hidden", "false");
        } else {
          $(self)
            .find(".facet-content")
            .prop("aria-hidden", "true");
        }
      });
      $(facet).on("keyup", "h3", function(e) {
        if (e.keyCode == "13") {
          self.toggleClass("facet-open");
        }
      });
    });
  }

  sortFacetItems(facets){
    function getCount(labelWithCount){
      if(!labelWithCount){
        return 0;
      }
      return parseInt(labelWithCount.replace('(','').replace(')'),10);
    }
    function facetItemsSorter(a,b) {
      let aSelected = a.classList.contains('selected');
      let bSelected = b.classList.contains('selected');
      let aText = a.querySelector('label').textContent||'';
      let bText = b.querySelector('label').textContent||'';
      let aCount = getCount(a.querySelector('.count').textContent||'0');
      let bCount = getCount(b.querySelector('.count').textContent||'0');
      if(aSelected || bSelected){
        if(aSelected && !bSelected){
          return -1;
        }else if(!aSelected && bSelected){
          return 1;
        }
        if(!(bCount - aCount)){
          if(aText < bText){
            return -1;
          }else if(aText > bText){
            return 1;
          }
          return 0;
        }
        return bCount - aCount;
      } else if(!(bCount - aCount)){
        if(aText < bText){
          return -1;
        }else if(aText > bText){
          return 1;
        }
        return 0;
      }
      return bCount - aCount;
    }
    facets.each(function(index, facet) {
      let facetFilter = $(facet).find('.facet-content .filter');
      if(!facetFilter.find('li:not(.filter-disabled)').length){
        // add empty filters text
        facetFilter.parents('.facet-content').find('.no-items').addClass('show');
      }else{
        // add empty filters text
        facetFilter.parents('.facet-content').find('.no-items').removeClass('show');
      }
      facetFilter.html($.makeArray(facetFilter.find('li')).sort(facetItemsSorter).map(function(v){return v.outerHTML}).join(''));
      if(!facetFilter.find('li:not(.filter-disabled)').length){
        // add empty filters text
        facetFilter.parents('.facet-content').find('.no-items').addClass('show');
      }else{
        // add empty filters text
        facetFilter.parents('.facet-content').find('.no-items').removeClass('show');
      }
    });
  }

  applyDatePicker(selector) {
    new DatePicker(selector, {
      field: selector,
      format: "DD-MM-YYYY",
      yearRange: [2000, 2040],
      maxDate: new Date(),
      firstDay: 1,
      onSelect: function(date) {
        this._o.field.setAttribute(
          "data-date-selected",
          moment(date).format("DD-MM-YYYY")
        );
        // this._o.field.setAttribute(
        //   "value",
        //   moment(date).format("DD-MM-YYYY")
        // );
        // this._o.field.value = moment(date).format("DD-MM-YYYY");
        if (this._o.field.id == "dateFrom") {
          this._o.field.setAttribute(
            "data-date-from",
            moment(date)
              .startOf("day")
              .format("YYYY-MM-DDTHH:mm:ss") + "Z"
          );
        } else {
          this._o.field.setAttribute(
            "data-date-to",
            moment(date).format("YYYY-MM-DDTHH:mm:ss") + "Z"
          );
          $(".datepicker button").prop("disabled", false);
        }
        var checkAndDisableButton = function() {
          let dateFrom = $("#dateFrom").attr("data-date-from"),
            dateTo = $("#dateTo").attr("data-date-to");
          $(".datepicker button").attr("data-facet-params", `{"cmd":"AddPm"}`);
          $(
            ".datepicker button"
          ).data().facetParams.val = `WVPUBDATE|[${dateFrom} TO ${dateTo}]`;
        };
        checkAndDisableButton();
      }
    });
  }

  setUpEvents() {
    var self = this;

    $(window).on("abacus:popuploaded", function(evt, context) {
      if (
        $(context)
          .data()
          .hasOwnProperty("openModal") &&
        !$(".abacusPopup").hasClass("facetModal")
      ) {
        var facets = $(".abacusPopup .facet"),
          popup = new InitPopup(document);
        $(".abacusPopup").addClass("facetModal");
        self.toggleFacet(facets, ".facet-toggle-container");
        $(".abacusPopup [data-popup-close]").on("click", function() {
          popup.close();
        });
      }
    });

    // show all facet in popup
    this.element.on("click", ".facet-show-all a", function(evt) {
      evt.preventDefault();
    });

    // filter button from mobile to show filter in overlay
    this.element.on("click", ".filterSkipLink", function(e) {
      e.preventDefault();
      $("body").addClass("mobile-ajax-overlay");
    });

    // button from mobile to close filter in overlay
    this.element
      .find("[data-mobile-filter-close]")
      .on("click", e => $("body").removeClass("mobile-ajax-overlay"));

    // disable button
    this.element.find(".datepicker button").prop("disabled", true);

    // when date range is completed
    this.element
      .find(".date-picker[data-rule-searchdateformat]")
      .each(function() {
        self.applyDatePicker(this);
      });

    // Reset all filters
    this.element.on("click", ".removeAllFilters", function(e) {
      e.preventDefault();

      //self.data.qkeyword = ""; PW Commented out
      self.data.parametrics = "";
      self.data.val = "";
      self.data.PageSize = "";

      $(self.options.form)
        .find('input[type="checkbox"][data-facet-params]')
        .each(function() {
          $(this)
            .prop("checked", false)
            .prop("disabled", false)
            .removeAttr("checked");
          $(this).data().facetParams.cmd = "AddPm";
          $(this)
            .parent()
            .removeClass("filter-disabled");
          self.unhighlightSelected(this);
        });
      //if ($("#facetKeyword").length > 0) { PW Commented out
      //  $("#facetKeyword")[0].value = "";
      //}
      $(".date-picker")
        .prop("disabled", false)
        .removeAttr("data-date-selected")
        .removeAttr("data-date-from")
        .removeAttr("data-date-to")
        .removeAttr("value")

        .removeProp("data-date-selected")
        .removeProp("data-date-from")
        .removeProp("data-date-to")
        .prop("value","")

        .parents("li")
        .removeClass("filter-disabled");

      $("#filterdatebtn")
        .removeProp("data-facet-params");

      self.request(this);
    });



    // filter clicking
    this.element.on("click", "[data-facet-params], [data-keyboard-event]", function(evt) {
     
      if ($(this).is("a")) evt.preventDefault();
 
      // date checkboxes
      if ($(this).data("dateFilter")) {
        if (this.checked) self.disableSiblings(this, true);
        else self.disableSiblings(this, false);
      }

      // rating filtering
      if ($(this).data("ratingFilter")) {
        if (this.checked) self.disableSiblings(this, true);
        else self.disableSiblings(this, false);
      }
     
      // add/remove/update attributes for serialisation
      if ($(this).is("input")){
        if(this.checked){
          $(this).attr('checked','checked').data().facetParams.cmd="AddPm";
        }else{
          $(this).removeAttr('checked').data().facetParams.cmd="RmvPm";
        }
      }

      self.request(this);
    });

    
    // sorting options
    this.element.on("change", "[data-submit-form-on-change]", function(e) {
      e.preventDefault();
      self.request($(this).find("option:selected"));
    });

    // active filters
    this.element.on("click", this.options.activefilter, function(evt) {
      evt.preventDefault();
      var ID = $(this).data("filterId");
      if ($(this).hasClass("applied-date-filter")) {
        $(".date-picker, [data-date-filter]")
          .prop("disabled", false)
          .prop("checked", false)
          .parents("li")
          .removeClass("filter-disabled selected");
      }
      if ($(this).hasClass("applied-rating-filter")) {
        $("[data-rating-filter][type=checkbox]")
          .prop("disabled", false)
          .prop("checked", false)
          .parents("li")
          .removeClass("filter-disabled selected");
      }
      // remove checkbox from facets
      // $('#'+ID).removeAttr('checked');
      // switch param on `Apply` button
      if (
        $(this)
          .data("facetParams")
          .val.includes("WVPUBDATE") &&
        $("#filterdatebtn").data("facetParams")
      ) {
        $("#filterdatebtn").data().facetParams.cmd = "AddPm";
      }

      // toggle display by matching ID from applied filter to item in facet
      $(self.options.form)
        .find('input[type="checkbox"][data-facet-params]')
        .each(function() {
          if (this.id == ID) {
            $(this)
              .prop("checked", false)
              .prop("disabled", false)
              .removeAttr("checked");
            $(this).data().facetParams.cmd = "AddPm";
            self.unhighlightSelected(this);
            return;
          }
        });

      // toggle display of checked dates
      let dates = $("[data-date-filter]:checked").length;
      let dateFromOrTo = $("[data-date-selected]").length;
      if (!dates&&!dateFromOrTo) {
        $(".date-picker, [data-date-filter]")
          .prop("disabled", false)
          .parents("li")
          .removeClass("filter-disabled");
      }

      // self.disableDateRangeFields();
      if($(this).data("facetParams").val.includes("WVPUBDATE")){
        $(".date-picker").each((index, field) => {
          // self.applyDatePicker(field);
          field.value = "";
        });
      }

      // we update array with applied filters for history
      self.getCheckedAndPushToArr();
    });

    // facet form (used for submitting dates)
    this.element.on("submit", "#facet-search", function(e) {
      e.preventDefault();
      self.disableAllDateFields();
    });

    // sub keyword filtering
    this.element.on("submit", "#keyword-search", function(e) {
      e.preventDefault();
      let field = $(this).find(".text")[0],
        obj = self.data;
      if (field.value.length > 0) {
        let elemData = $(field).data("facetParam");
        elemData.qkeyword = field.value;
        elemData.val = field.value;

        if (obj.facets) delete obj.facets;
        if (obj.total) delete obj.total;

        self.data = $.extend(obj, elemData);
        self.request(this);
      } else {
        // when submitted and no value type in
        if (obj.facets) delete obj.facets;
        if (obj.total) delete obj.total;
        if (obj.hasOwnProperty("qkeyword")) {
          obj.qkeyword = "";
          delete obj.cmd;
          delete obj.val;
        }
        self.request(this);
      }
    });

    // set initial state for date picker fields
    let srData = $(".refineBy[data-search-results]").data("searchResults");
    if(srData){
      if(srData.parametrics.indexOf("WVPUBDATE") != -1){
        let dateRanges = srData.parametrics.split(",").filter(param => param.indexOf("WVPUBDATE") != -1).map(range => (range.indexOf("WVPUBDATE")!=-1? range.replace("WVPUBDATE|",""):"")).map(x=>x.replace("[","").replace("]","")).join("").split(" TO ");
        // if(dateRanges){
        if(dateRanges&&(srData.cmd!="RmvPm"&&srData.val&&srData.val.indexOf("WVPUBDATE")!=-1)){
          let dateFrom = document.querySelector("#dateFrom:not([disabled])"), dateTo = document.querySelector("#dateTo:not([disabled])");

          if(dateFrom&&dateRanges.length){
            self.applyDatePicker(dateFrom);
            dateFrom.value = dateRanges[0].split("T")[0];
            dateFrom.setAttribute("data-selected",dateRanges[0].split("T")[0]);
            dateFrom.setAttribute("data-date-from",dateRanges[0]);
            dateFrom.disabled = true;
            dateFrom.setAttribute("disabled","disabled");
          }

          if(dateTo&&dateRanges.length>1){
            self.applyDatePicker(dateTo);
            dateTo.value = dateRanges[1].split("T")[0];
            dateTo.setAttribute("data-selected",dateRanges[1].split("T")[0]);
            dateTo.setAttribute("data-date-to",dateRanges[1]);
            dateTo.disabled = true;
            dateTo.setAttribute("disabled","disabled");
          }
        }
      }
    }

    // if (value.substring(0, 9) === "WVPUBDATE") {
    //   $(".date-picker:not([disabled])").each((index, field) => {
    //     this.applyDatePicker(field);
    //     field.value = $(field).data("dateSelected");
    //   });
    //   // this.disableDateRangeFields(true);
    //   // $(".date-picker").each((index, field) => {
    //   //   this.applyDatePicker(field);
    //   //   field.value = $(field).data("dateSelected");
    //   // });
    //   debugger;
    //   self.disableAllDateFields();
    // }

    $(window).on("abacus:ajaxsearch:success", function() {
      if ($("#searchResults #colmain").is(":offscreen")) {
        jump("#colmain", {
          duration: 1000,
          offset: -200
        });
      }
    });
  }

  disableAllDateFields() {
    $(".date-picker, [data-date-filter]")
      .prop("disabled", true)
      .parents("li");
    // .addClass("filter-disabled");
  }

  highlightSelected(element) {
    if (element&&element.checked) {
      setTimeout(() => {
        $(element).focus();
      }, 0);
      $(element)
        .parent()
        .addClass("selected");
    } else {
      this.unhighlightSelected(element);
    }
  }

  unhighlightSelected(element) {
    $(element)
      .parent()
      .removeClass("selected");
  }

  switchParams(element) {
    if ($(element).data("facetContext") || element === null || $(element).is("#filterdatebtn")) return;
    if($(element).data()){
      if ($(element).data().facetParams.cmd == "AddPm") {
        $(element).data().facetParams.cmd = "RmvPm";
      } else {
        $(element).data().facetParams.cmd = "AddPm";
      }
    }
  }

  updateCount(data) {
    // Push arrays
    let myArray = [];
    data.filter(set => myArray.push(set.filters));
    // Flatten array
    let flatArray = [].concat(...myArray);

    const filtersCollection = $(
      ".facet [data-facet-params]:not([data-date-filter]):not([data-rating-filter])"
    );

    $(filtersCollection)
      .prop("disabled", true)
      .parent("li")
      .addClass("filter-disabled")
      .find(".count")
      .text("(0)");

    $('#explorer-search input[type="radio"]').prop("disabled", false);

    filtersCollection.each(function(i, el) {
      let id = el.id;
      flatArray.find(facet => {
        if (facet.code === id) {
          return $(el)
            .prop("disabled", false)
            .parent("li")
            .removeClass("filter-disabled")
            .find(".count")
            .text(`(${facet.count})`);
        }
      });
    });
  }

  disableSiblings(element, state) {
    var target = $(element)
      .parent("li")
      .siblings();
    if (state) {
      $(element)
        .parent("li")
        .siblings()
        .addClass("filter-disabled")
        .find('[type="checkbox"]')
        .prop("disabled", true);
      $(element)
        .parent("li")
        .siblings()
        .find('[type="text"]')
        .prop("disabled", true);
      $(element)
        .parent("li")
        .siblings(".date-picker")
        .find("button")
        .prop("disabled", true);
    } else {
      $(element)
        .parent("li")
        .siblings()
        .removeClass("filter-disabled select")
        .find('[type="checkbox"]')
        .prop("disabled", false)
        .prop("checked", false)
        .removeAttr("checked");
      $(element)
        .parent("li")
        .siblings()
        .find('[type="text"]')
        .prop("disabled", false);
      $(element)
        .parent("li")
        .siblings(".date-picker")
        .find("button")
        .prop("disabled", false);
    }
  }

  collectSelectedParams(element) {
    let parametrics = this.data.parametrics,
      facetParams = $(element).data("facetParams");
    let dataSet = { parametrics };

    $.extend(dataSet, facetParams);
    if (this.data.facets) delete this.data.facets;
    return $.extend(this.data, dataSet);
  }

  contentReplaceActiveFilters(html) {
    // sort elements
    // replaces active filters (left side)
    this.element
      .find(".activeFilters")
      .replaceWith($(html).filter(".activeFilters"));
  }

  contentReplaceHeader(html) {
    // replaces header - PW added below and commented out
    this.element.find(".searchDetails div p.highlight").replaceWith(
      $("<div>")
        .html(html)
        .find(".searchDetails div p.highlight")
    );
    this.element.find("div.tabs div.tabs-inner").replaceWith(
      $("<div>")
        .html(html)
        .find("div.tabs div.tabs-inner")
    );
    if (
      !this.element.find(".searchDetails div p.highlight").hasClass("directory")
    ) {
      this.element.find(".searchDetails div form").replaceWith(
        $("<div>")
          .html(html)
          .find(".searchDetails div form")
      );
    }

    //this.element.find(".searchDetails").replaceWith(
    //  $("<div>")
    //    .html(html)
    //    .find(".searchDetails")
    //  );
  }

  contentReplaceMainAndPaging(html, data) {
    if (data.total > 0) {
      // replaces content which includes paging
      this.element
        .find(`${this.options.results}`)
        .replaceWith(
          $("<div>")
            .html(html)
            .find(`${this.options.results}`)
        )
        .removeClass("reset-list-to-default");

      // reinit event listeners for results to enable back to search results link
      $(".directory-search .listBlocks").on(
        "click",
        ".image,.link-headline,.company-articles,.link-company",
        function() {
          localStorage.setItem(
            "abacus:searchfilter:applied",
            location.pathname + location.search + location.hash
          );
        }
      );
    } else {
      //this.element.find(".highlight").replaceWith($(html).find(".highlight")); PW commented out

      //removes results and sort box
      this.element
        .find(`${this.options.results} .listBlocks`)
        .html(
          $(html)
            .find(".highlight")
            .nextAll()
        )
        .addClass("reset-list-to-default");
      //remove directory header
      this.element.find(".searchresults__header").remove();

      //remove paging
      this.element.find(".paging").empty();
      //remove sort box
      //this.element
      //    .find(".searchDetails")
      //    .find(".highlight")
      //    .nextAll()
      //    .remove();

      //adds no results pagetext - ONLY do if not on page already
      if (
        $("<div>")
          .html(html)
          .find(".searchresults__header").length > 0
      ) {
        $("<div>")
          .html(html)
          .find(".searchresults__header")
          .insertBefore(
            this.element.find(
              ".contentWrapperLeft.search-results-list >div:first-child"
            )
          );
      }

      //related blocks
      if ($(html).find(".relatedResults").length > 0) {
        this.element
          .find(`${this.options.results} .listBlocks`)
          .removeClass("reset-list-to-default")
          .empty()
          .append($(html).find(".relatedResults"));
      }
    }
  }

  updateCountsForMobile(data) {
    // UPDATES COUNTS OF HEADER AND BUTTON AT MOBILE ONLY
    let filterLength = $("#facet-search input:checked").length,
      facetCountElement = $(".mobile-filter-header h3 span.count");
    if (filterLength == 0) {
      facetCountElement.empty();
      $(".filterSkipLink .count").empty();
    } else {
      facetCountElement.text(`(${filterLength})`);
      $(".filterSkipLink .count").html(`(${filterLength})`);
    }

    if (data.results.total > 0) {
      $(".mobile-filter-results button")
        .text(`(${data.results.total}) Results`)
        .prop("disabled", false);
    } else {
      $(".mobile-filter-results button")
        .text(`(${data.results.total}) Results`)
        .prop("disabled", true);
    }
  }

  scrollToTopWithAnimation(element) {
    $("html, body").animate(
      {
        scrollTop: $("#columns").offset().top - 60
      },
      750
    );
  }

  getCheckedAndPushToArr() {
    let _self = this;
    this.selectedArr.length = 0;
    $("input[data-facet-params]:checked").each((ind, element) => {
      _self.selectedArr.push(element.id);
    });

    if ($(".datepicker button").data("facetParams") !== undefined) {
      this.selectedArr.push($(".datepicker button").data("facetParams").val);
    }
  }

  request(el) {
    let data = $(el).data("facetContext")
      ? this.data
      : this.collectSelectedParams(el);

    this.getCheckedAndPushToArr();

    let datacopy = $.extend({}, data);
    datacopy.selectorArr ? delete datacopy.selectorArr : "";
    datacopy.total ? delete datacopy.total : "";

    localStorage.setItem(
      "abacus:searchfilter:applied",
      `${location.pathname}?${$.param(datacopy)}`
    );

    const response = new Promise((resolve, reject) => {
      $.ajax({
        url: this.element.find(".searchDetails").data("searchUrl"),
        data: datacopy,
        beforeSend: () => this.element.addClass("loading"),
        success: data => resolve(data)
      });
    });

    var self = this;

    response.then(data => {
      let handlerData = JSON.parse(
          $(data)
            .filter("script")
            .html()
        ),
        htmlData = $(data)
          .filter("resulthtml")
          .html(),
        hierarchicalHTML = $(data)
          .filter("hierarchicalfacethtml")
          .html();

      $(window).trigger("abacus:ajaxsearch:success", [self.selectedArr]);
      self.data = $.extend(self.data, handlerData.results);

      self.contentReplaceActiveFilters(htmlData);
      self.contentReplaceHeader(htmlData);
      self.contentReplaceMainAndPaging(htmlData, handlerData.results);

      $("#explorer-search-list").replaceWith(hierarchicalHTML);


      // console.log(self.selectedArr);
      
      if (!$(el).data("facetContext")) {
      // if (!$(el).data("facetContext") && el !== null ){
      //   // || $(element).is("#filterdatebtn")
        self.highlightSelected(el);
        self.switchParams(el);
      }
      
      self.updateCount(self.data.facets);
      if (self.data.facets) delete self.data.facets;
      
      self.updateCountsForMobile(handlerData);
      self.sortFacetItems(self.element.find(".facet:not(.byRating):not(.byDate)"));
      self.ratingTabindex();
      $(self.element).removeClass("loading");

      self.scrollToTopWithAnimation(el);

      $(window).trigger("abacus:ajaxsearch:complete", [self.element]);
      // Abacus.UI(document.body);
      $(window).trigger("abacus:InitUI", [document.body]);
    });
  }
}

export { SearchAJAX };



// WEBPACK FOOTER //
// ./Javascript/core/classes/searchresults/search.ajax.js